<template>
  <v-card class="card-form">
    <v-card-title class="text-h5">
      <img
        class="card-form__logo"
        :src="require('@/assets/svg/logo.svg')"
        alt=""
      >
    </v-card-title>
    <hr class="card-form__hr-solid" />
    <v-card-text style="width: 25rem;">
      <div class="card-form__name">
        Reset your password
      </div>
      <v-alert
        :model-value="!!errorText.length"
        closable
        type="error"
        @update:model-value="errorText = []"
      >
        {{ errorText[0] }}
      </v-alert>
      <v-alert
        :model-value="!!infoText"
        closable
        type="info"
        @update:model-value="infoText = ''"
      >
        {{ infoText }}
      </v-alert>

      <div
        v-if="!infoText"
        class="card-form__main"
      >
        <v-form
          ref="form"
          @submit.prevent="sendForm()"
        >
          <v-text-field
            v-model="email"
            label="Your email"
            color="primary"
            placeholder="Enter your email"
            :rules="[rules.required, rules.isEmail]"
            variant="outlined"
          />
          <v-btn
            type="submit"
            class="card-form__send-button"
            color="primary"
            size="large"
          >
            Send New Password
          </v-btn>
        </v-form>
      </div>
      <div class="card-form__footer">
        Don’t have an account? <a
          href="/"
          @click.prevent="$emit('change', 'signup')"
        >Sign up here</a>
      </div>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import { Vue, Component, Prop, Emit } from 'vue-facing-decorator'
import validationRules from '../../validation/validationRules'

@Component({
  emits: ['change']
})
export default class ResetPasswordForm extends Vue {
  infoText = ''
  errorText = []
  email = ''
  rules = {
    required: v => validationRules.checkRequired(v) || '',
    isEmail: v => validationRules.checkEmail(v) || '',
  }

  async isValid (): Promise<boolean> {
    return (this.$refs.form as typeof Vue & { validate: () => boolean }).validate()
  }

  async sendForm () {
    const isValid: any = await this.isValid()
    if (!isValid.valid) return false

    try {
      this.infoText = await this.$api.auth.resetPassword({ email: this.email })
      setTimeout(() => {
        this.infoText = ''
        this.$emit('sent');
      }, 3000)
    } catch (data: any) {
      this.errorText = []
      if (data) {
        for (const key in data) {
          this.errorText.push(data[key][0])
        }
      }
    }
  }

  resetPassword () {
    return this.$api.auth.resetPassword({ email: this.email })
  }
}
</script>
